<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="responsiveHeaders"
      :items="games"
      hide-default-footer
      mobile-breakpoint="1"
      @click:row="onRowClicked"
      :items-per-page="1000"
    >
      <template v-slot:item.type="{ item }">
        <v-badge
          color="accent"
          :overlap="true"
          :value="item.yourUnreadChatMessages ? item.yourUnreadChatMessages > 0 : false"
          :content="item.yourUnreadChatMessages"
        >
          <multi-icon
            :icon="getGameTypeIcon(item.type)"
            :rightBottomIcon="getPlatformIcon(item.platform)"
            :rightBottomIconColor="'var(--v-secondary-base)'"
          />
        </v-badge>
      </template>
      <template v-slot:item.name="{ item }">
        <div v-if="item.portals">
          <div v-for="portal in item.portals" v-bind:key="portal.uid">
            <span class="portal caption">{{portal.name}}</span>
          </div>
        </div>
        <span>{{item.name}}</span>
        <div>
          <span class="caption text--secondary">{{getGameName(item.game)}}</span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import gameMixin from "@/mixins/gameMixin";
import commonMixin from "@/mixins/commonMixin";
import platformMixins from "@/mixins/platformMixins";
import gameTypeMixin from "@/mixins/gameTypeMixin";

export default {
  name: "GameList",
  mixins: [commonMixin, platformMixins, gameTypeMixin, gameMixin],
  components: {},
  props: {
    games: {
      type: Array,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      headers: [
        {
          text: "",
          align: "center",
          sortable: true,
          class: "typeCol",
          value: "type",
          width: "1.2em"
        },
        {
          text: this.$t('common.name'),
          sortable: true,
          value: "name"
        },
      ]
    };
  },
  computed: {
    responsiveHeaders() {
      return this.$vuetify.breakpoint.name === "xs"
        ? this.headers.filter(h => !["platform"].includes(h.value))
        : this.headers;
    }
  },
  methods: {
    onRowClicked(game) {
      this.$router.push({ name: 'competition', params: { gameUID: game.uid } })
    }
  }
};
</script>

<style scoped>
</style>